<div id="technical-container" class="container">
    <h1>
        <i class="fa fa-rocket fa-pre" aria-hidden="true"></i
        >{{ 'technicals.technical.title' | translate }}
    </h1>
    <h2>{{ 'technicals.technical.export.title' | translate }}</h2>
    <div>
        {{ 'technicals.technical.export.ca' | translate }}
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessions.selectedFromMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.sessions.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessions.selectedFromYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.sessions.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;et
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessions.selectedToMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.sessions.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessions.selectedToYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.sessions.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadCAExport(
                    data.export.sessions.selectedFromYear,
                    data.export.sessions.selectedFromMonth,
                    data.export.sessions.selectedToYear,
                    data.export.sessions.selectedToMonth,
                    'ZNK',
                    'text/csv',
                    'ca-export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Zenika
        </button>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadCAExport(
                    data.export.sessions.selectedFromYear,
                    data.export.sessions.selectedFromMonth,
                    data.export.sessions.selectedToYear,
                    data.export.sessions.selectedToMonth,
                    'ST',
                    'text/csv',
                    'ca-export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Sous-traitant
        </button>
    </div>

    <br />

    <div>
        Export des compétences des formateurs et formatrices
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadTrainerSkills(
                    'text/csv',
                    'trainer_skills_export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />

    <div>
        Export de l'historique de staffing entre
        <select
            class="standard-margin"
            [(ngModel)]="data.export.staffingHistory.selectedFromMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.staffingHistory.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.staffingHistory.selectedFromYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.staffingHistory.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;et
        <select
            class="standard-margin"
            [(ngModel)]="data.export.staffingHistory.selectedToMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.staffingHistory.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.staffingHistory.selectedToYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.staffingHistory.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadStaffingHistory(
                    data.export.staffingHistory.selectedFromYear,
                    data.export.staffingHistory.selectedFromMonth,
                    data.export.staffingHistory.selectedToYear,
                    data.export.staffingHistory.selectedToMonth,
                    'text/csv',
                    'staffing_history_export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />

    <div>
        Export des stagiaires ayant accepté d'être contacté, pour les sessions entre
        <select
            class="standard-margin"
            [(ngModel)]="data.export.contactableStudents.selectedFromMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.contactableStudents.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.contactableStudents.selectedFromYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.contactableStudents.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;et
        <select
            class="standard-margin"
            [(ngModel)]="data.export.contactableStudents.selectedToMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.contactableStudents.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.contactableStudents.selectedToYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.contactableStudents.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadContactableStudents(
                    data.export.contactableStudents.selectedFromYear,
                    data.export.contactableStudents.selectedFromMonth,
                    data.export.contactableStudents.selectedToYear,
                    data.export.contactableStudents.selectedToMonth,
                    'text/csv',
                    'contactable_students_export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />

    <div>
        Export des inscriptions entre
        <select
            class="standard-margin"
            [(ngModel)]="data.export.registrations.selectedFromMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.registrations.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.registrations.selectedFromYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.registrations.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;et
        <select
            class="standard-margin"
            [(ngModel)]="data.export.registrations.selectedToMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.registrations.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.registrations.selectedToYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.registrations.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadRegistrations(
                    data.export.registrations.selectedFromYear,
                    data.export.registrations.selectedFromMonth,
                    data.export.registrations.selectedToYear,
                    data.export.registrations.selectedToMonth,
                    'text/csv',
                    'inscriptions-export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />

    <div>
        Export des notes basses entre
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluations.selectedFromMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.evaluations.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluations.selectedFromYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.evaluations.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;et
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluations.selectedToMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.evaluations.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluations.selectedToYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.evaluations.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadGrades(
                    data.export.evaluations.selectedFromYear,
                    data.export.evaluations.selectedFromMonth,
                    data.export.evaluations.selectedToYear,
                    data.export.evaluations.selectedToMonth,
                    'text/csv',
                    'grades-export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />

    <div>
        Export du nombre de sessions, de clients, de stagiaires et du chiffre d'affaire par mois, formation, et agence entre
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessionStats.selectedFromMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.sessionStats.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessionStats.selectedFromYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.sessionStats.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;et
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessionStats.selectedToMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.sessionStats.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.sessionStats.selectedToYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.sessionStats.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadSessionStats(
                    data.export.sessionStats.selectedFromYear,
                    data.export.sessionStats.selectedFromMonth,
                    data.export.sessionStats.selectedToYear,
                    data.export.sessionStats.selectedToMonth,
                    'text/csv',
                    'stats_by_year_and_training_and_trainer_company.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />

    <div>
        Export des évaluations des stagiaires, formateurs et formatrices par session entre
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluationsBySession.selectedFromMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.evaluationsBySession.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluationsBySession.selectedFromYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.evaluationsBySession.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;et
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluationsBySession.selectedToMonth"
            style="width: 100px"
        >
            <option
                *ngFor="let month of data.export.evaluationsBySession.months"
                [value]="month.value"
            >
                {{ month.label }}
            </option>
        </select>
        <select
            class="standard-margin"
            [(ngModel)]="data.export.evaluationsBySession.selectedToYear"
            style="width: 50px"
        >
            <option
                *ngFor="let year of data.export.evaluationsBySession.years"
                [value]="year"
            >
                {{ year }}
            </option>
        </select>
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadEvaluationsBySession(
                    data.export.evaluationsBySession.selectedFromYear,
                    data.export.evaluationsBySession.selectedFromMonth,
                    data.export.evaluationsBySession.selectedToYear,
                    data.export.evaluationsBySession.selectedToMonth,
                    'text/csv',
                    'evaluations_by_session_export.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />
    <div>
        Export du suivi de la formation de formateur
        <button
            class="standard-margin btn btn-default doc-buttons"
            (click)="
                downloadTrainersTrainingReport(
                    'text/csv',
                    'formation-de-formateurs.csv'
                )
            "
        >
            <i class="fa fa-download" aria-hidden="true"></i>Télécharger
        </button>
    </div>

    <br />

    <h2>{{ 'technicals.technical.mail.title' | translate }}</h2>
    <div>
        {{ 'technicals.technical.mail.message' | translate }}
        {{ data.mail.size }}
    </div>

    <br />
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/technical/technical.component.html